// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2yUvB","footer":"ModalInfo_footer__1H-ju"};